<template>
  <div id="roles-list" class="roles-list-container">
    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      pagination
      :max-items="itemsPerPage" search :data="roleList"
    >
    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <div
        class="
          p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
          text-lg font-medium text-base text-primary border border-solid border-primary
        "
        @click="sidebarIsActive = true"
      >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Adicionar Novo</span>
      </div>
      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 ml-auto">
        <div class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            ">
          <span class="mr-2">
            {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
            {{
              roleList.length - currentPage * itemsPerPage > 0
              ? currentPage * itemsPerPage
              : roleList.length
            }} of {{ queriedItems }}
          </span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="itemsPerPage = 4">
            <span>4</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="itemsPerPage = 10">
            <span>10</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="itemsPerPage = 15">
            <span>15</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="itemsPerPage = 20">
            <span>20</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="actions">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.display_name }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <RoleSidebar 
      :sidebarIsActive="sidebarIsActive"
      @isActiveFalse="sidebarIsActive = false"
      @successfullyCreated="successfullyCreatedRole"
    />
  </div>
</template>

<script>
  import role from '../../http/requests/role/index';
  import RoleSidebar from './RolesSidebar';
  import TableRoles from './TableRoles'

  export default {
    name: 'roles-list',
    data() {
      return {
        itemsPerPage: 5,
        isMounted: false,
        roleList: [],
        sidebarIsActive: false,
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }

        return 0
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.roles.length
      }
    },
    methods: {
      verify(){
        const permissions = localStorage.getItem('permissions');
        const twoFactor = localStorage.getItem('twoFactor')
        if(!permissions && !twoFactor){
            this.$router.push('/user-settings')
        }else if(!permissions && twoFactor){
            this.$router.push('/two-factor')
        }
      },
      addNewData() {
        this.$router.push(formatRouteTenantPath(`/roles/add`))
      },
      deleteData(roleId) {
        this.$store.dispatch("role/delete", roleId)
        .catch(err => { console.error(err) })
      },
      editData(roleId) {
        this.$router.push(`/roles/edit/${roleId}`)
      },
      canSee(action) {
        return hasPermission(`roles-${action}`)
      },
      async roles() {
        await role.fetchRoles()
        .then(response => this.roleList = response.data)
        .catch(Exception => console.log(Exception));
      },
      successfullyCreatedRole(response) {
        this.sidebarIsActive = false;
        this.roles();
      }
    },
    created() {
      this.roles();
    },
    mounted() {
      this.isMounted = true;
      this.verify()
    },
    components: {
      TableRoles,
      RoleSidebar
    },
    beforeRouteLeave(to, from, next) {
      this.sidebarIsActive = false;
      setTimeout( ()=> {
        next();
      }, 10);
    },
  }
</script>

<style lang="scss">
  #roles-list {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
